import React from 'react'
import Link from './Link'

const SocialMediaLinks = () => {
  return (
    <React.Fragment>
      <Link
        href="https://www.facebook.com/ramling.suryawanshi.5"
        target={"_blank"}
      >
        <i className="fa fa-facebook-square" />
      </Link>
      <Link href="#" target={"_blank"}>
        <i className="fa fa-google-plus-square" />
      </Link>
      <Link
        href="https://www.linkedin.com/in/ram-suryawanshi/"
        target={"_blank"}
      >
        <i className="fa fa-linkedin" />
      </Link>
      <Link href="#" target={"_blank"} rel="noreferrer">
        <i className="fa fa-youtube-square" />
      </Link>
      <Link
        href="https://twitter.com/RamSury32873398"
        target={"_blank"}
        rel="noreferrer"
      >
        <i className="fa fa-twitter" />
      </Link>
    </React.Fragment>
  );
};

export default SocialMediaLinks;